import React, {useState} from "react";
import {Autocomplete, Container, TextField} from "@mui/material";
import {CompanyAddressDetails, countryOptions, getAddressCountry, getCountryCode, getCountryOption} from "../../assets/address-details";

export default function AddressDetailsEditor({initialAddress, singleLine = false, onChange}: {
    initialAddress: CompanyAddressDetails;
    singleLine?: boolean;
    onChange: (field: keyof CompanyAddressDetails, value: string | null) => void;
}) {
    const [address, setAddress] = useState(initialAddress);
    const country = getAddressCountry(address);
    const isUS = getCountryCode(country) === "US";
    const update = (key: keyof CompanyAddressDetails, value: string | null) => {
        const next = {...address, [key]: value};
        setAddress(next);
        onChange(key, value);
    };
    const fields: {key: keyof CompanyAddressDetails; label: string; required: boolean}[] = [
        {key: singleLine ? "address" : "street1", label: singleLine ? "Address" : "Address 1", required: true},
        ...(!singleLine ? [{key: "street2" as const, label: "Address 2", required: false}] : []),
        {key: "city", label: "City", required: true},
        {key: "state", label: isUS ? "State" : "State / Province / Region", required: isUS},
        {key: "zipCode", label: isUS ? "ZIP Code" : "Postal Code", required: isUS},
    ];

    return <Container disableGutters>
        {fields.map(({key, label, required}) => <TextField
            key={key}
            fullWidth
            required={required}
            label={label}
            margin="normal"
            value={address[key] ?? ""}
            inputProps={{maxLength: 255}}
            onChange={event => update(key, event.target.value)}
        />)}
        <Autocomplete
            disablePortal
            disableClearable
            options={countryOptions}
            value={getCountryOption(country)}
            isOptionEqualToValue={(option, value) => option.code === value.code}
            onChange={(_, option) => update("country", option.code ?? "Unknown")}
            renderInput={params => <TextField {...params} label="Country" margin="normal"/>}
        />
    </Container>;
}
